"use client";

import React from "react";
import { ProductJson } from "@/types/Product.type";
import ProductRating from "~components/product/productRating/ProductRating";
import ProductTags from "~components/product/ProductTags";
import LinkElement from "@/components/LinkElement";
import Skeleton from "@/components/Skeleton";
import ShareSocial from "@/components/ShareSocial";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import PromotionListView from "~components/promotion/PromotionListView";
import { getPromotionValid } from "@/utils/product";
import usePromotions from "@/lib/hooks/usePromotions";
import { PromotionGroupType } from "@/types/Promotion.type";

type ProductInfoProps = {
	data: ProductJson;
	productVariantActive: ProductJson;
	// loading: boolean;
};
const translate = {
	product_brand: "product_brand",
};
const ProductInfo = ({
	data,
	productVariantActive,
}: // loading,
ProductInfoProps) => {
	const { t } = useTranslationApi(Object.values(translate));

	const { data: promotions } = usePromotions({ isOnlyValid: true });

	const promotionsBody =
		promotions?.filter((pro) => pro.discount_type === "order") || [];

	return (
		<>
			<div className=" mb-[10px]">
				<h1 className=" font-bold text-gray-500 line-clamp-2 text-lg flex gap-2">
					{data.name}
					<ShareSocial
						shareButtonProps={{
							url: `${process.env.REACT_APP_DOMAIN}/products/${data.handle}`,
							title: data.name + " - Namperfume",
						}}
					/>
				</h1>
			</div>
			<div className="flex items-center gap-2 mb-[10px]">
				<ProductRating item_id={data.id} defaultRating={data.rate} />
				{data?.tags?.length > 0 && (
					<ProductTags tags={data.tags} type="PRODUCT GENDER" />
				)}
			</div>

			{data?.brand ? (
				<div className="mb-[10px]">
					<span className=" text-base ">{t(translate.product_brand)}: </span>
					<LinkElement
						href={`/blogs/thuong-hieu-nuoc-hoa/${data?.brand?.handle}`}>
						<span className=" font-bold  hover:text-red-500   text-base">
							{" "}
							{data?.brand?.title}
						</span>
					</LinkElement>
				</div>
			) : null}

			{productVariantActive.option_name || productVariantActive.full_name ? (
				<span className=" text-base line-clamp-2 ">
					{productVariantActive.option_name || productVariantActive.full_name}{" "}
					{productVariantActive?.tags.length > 0 && (
						<ProductTags
							tags={productVariantActive.tags}
							className="inline-flex ml-2"
						/>
					)}
				</span>
			) : null}

			{promotionsBody && (
				<div className=" mt-[10px] hidden md:block">
					<PromotionListView promotions={promotionsBody} />
				</div>
			)}
		</>
	);
};

export default ProductInfo;
